import CartApi from '@apis/cart/CartApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const cartQueries = createQueryKeys('cart', {
    cartId: (shopId: string) => ({
        queryKey: [shopId],
        queryFn: () => CartApi.getCartIdByShopId(shopId),
    }),
    detail: (shopId: string, cartId: string) => ({
        queryKey: [shopId, cartId],
        queryFn: () => CartApi.getCart(shopId, cartId),
    }),
});

export default cartQueries;
